export default __webpack_public_path__ + "static/media/bti-img.e0fc9dce.webp";